// The SVV vehicle classes on the Andre kjøretøy page (#982). Personbil and
// Varebil are left out on purpose: their new cars belong to Nybilstatistikk.
// Motorredskap and Beltebil are left out as not relevant to the users.
// Bobil is SVV's Personbil narrowed to avgift code 316 (#1048).
// The key is the API's `gruppe` value and the URL segment.
import type { ComponentType } from 'react'
import { Bus, Tractor, Truck } from 'lucide-react'
import { Beltemotorsykkel, Bobil, Moped, Motorsykkel, Tilhenger } from './icons'

export const GRUPPER = [
  'lastebil', 'buss', 'bobil', 'motorsykkel', 'moped', 'traktor', 'tilhenger', 'beltemotorsykkel',
] as const

export type Gruppe = (typeof GRUPPER)[number]

export const DEFAULT_GRUPPE: Gruppe = 'lastebil'

export function isGruppe(value: string | undefined): value is Gruppe {
  return !!value && (GRUPPER as readonly string[]).includes(value)
}

export const GRUPPE_ICONS: Record<Gruppe, ComponentType<{ className?: string }>> = {
  lastebil: Truck,
  buss: Bus,
  bobil: Bobil,
  motorsykkel: Motorsykkel,
  moped: Moped,
  traktor: Tractor,
  tilhenger: Tilhenger,
  beltemotorsykkel: Beltemotorsykkel,
}
